import { utc } from './utc';
import { formatFn } from './tz/formatFn';
import { formatters } from './formatters';

/**
 * Devuelve el formato "pattern" de fecha del usuario, respetando su locale.
 *
 * Para eso, usa la tecnica de crear una fecha formateada
 * y reemplaza los numeros predeterminados por las letras de pattern correspondientes.
 *
 * El pattern devuelto depende del DATEFORMATS.
 * El DATEFORMATS por defecto es el `localized` en función del edicom.locale.id
 * Pero en el frontend por ej. se carga siempre un DATEFORMATS especifico.
 *
 * @example DATEFORMATS.localized; edicom.locale.id = 'es';
 * getLocalePattern(); -> "dd/MM/yyyy HH:mm:ss"
 * getLocalePattern('date'); -> "dd/MM/yyyy"
 *
 * @example DATEFORMATS.localized; edicom.locale.id = 'en';
 * getLocalePattern(); -> "MM/dd/yyyy hh:mm:ss aa"
 * getLocalePattern('timelong'); -> "hh:mm:ss aa"
 *
 * @example DATEFORMATS['yyyy/MM/dd HH:mm:ss'];
 * getLocalePattern(); -> "yyyy/MM/dd HH:mm:ss"
 * getLocalePattern('datetime'); -> "yyyy/MM/dd HH:mm"
 *
 * @param {string} format datetime|date|time|datetimelong|timelong
 * @returns {string}
 */
export function getPattern(state, format = 'datetimelong') {
  return formatters[format]?.(state, formatFn, utc(state, new Date(2022, 11, 31, 23, 59, 0)))
    .replace(',', '')
    .replace('31', 'dd')
    .replace('12', 'MM')
    .replace('2022', 'yyyy')
    .replace('23', 'HH')
    .replace('11', 'hh')
    .replace('59', 'mm')
    .replace('00', 'ss')
    .replace('PM', 'aa');
}
